<summa-details-tile-widget
  [title]="'common:dictionary.plural.automation' | i18nextCap"
  [counters]="sandbox.automationCounters$ | async"
  [route]="{ destination: ['automations'], tooltip: 'common:dictionary.view-all' | i18nextCap }"
  [totalCountLabel]="['dashboard:dashboard.total-number-of' | i18nextCap, 'common:dictionary.plural.automation' | i18next].join(' ')"
></summa-details-tile-widget>
